export const EXCEL_FUNCTION_CATEGORIES = [
  {
    "id": "calculate",
    "label": "Calculate totals & amounts",
    "icon": "∑",
    "description": "Add, multiply, subtotal and calculate business values."
  },
  {
    "id": "lookup",
    "label": "Look up & retrieve data",
    "icon": "⌕",
    "description": "Find records and return related values from tables."
  },
  {
    "id": "logic",
    "label": "Statement & Error Handling",
    "icon": "✓",
    "description": "Test conditions, classify results and control formula errors."
  },
  {
    "id": "text",
    "label": "Clean, split & combine text",
    "icon": "Aa",
    "description": "Prepare names, codes and imported text for reporting."
  },
  {
    "id": "date",
    "label": "Work with dates & schedules",
    "icon": "◷",
    "description": "Calculate deadlines, working days, periods and time values."
  },
  {
    "id": "array",
    "label": "Filter, sort & reshape lists",
    "icon": "▦",
    "description": "Create dynamic reports and transform ranges with modern arrays."
  },
  {
    "id": "round",
    "label": "Round & control numbers",
    "icon": "0.0",
    "description": "Control precision, signs, remainders and numeric presentation."
  },
  {
    "id": "statistics",
    "label": "Analyse data statistically",
    "icon": "↗",
    "description": "Summarise distributions, rankings, relationships and trends."
  },
  {
    "id": "financial",
    "label": "Loans, investments & finance",
    "icon": "$",
    "description": "Model payments, cash flows, returns and depreciation."
  },
  {
    "id": "information",
    "label": "Validate & inspect values",
    "icon": "i",
    "description": "Check data types, errors, blanks and workbook information."
  },
  {
    "id": "reference",
    "label": "Build references & navigation",
    "icon": "↔",
    "description": "Create flexible references and identify rows or columns."
  },
  {
    "id": "engineering",
    "label": "Convert & engineer values",
    "icon": "⚙",
    "description": "Convert units and work with technical number systems."
  },
  {
    "id": "database",
    "label": "Calculate from databases",
    "icon": "▤",
    "description": "Apply criteria-based calculations to structured lists."
  }
];
export const EXCEL_FUNCTIONS = [
  {
    "category": "calculate",
    "usage": "most-common",
    "name": "SUM",
    "description": "Adds numbers or ranges together.",
    "syntax": "SUM(number1, [number2], …)",
    "example": "=SUM(C2:C6)",
    "result": "364,000",
    "version": "All versions",
    "note": "",
    "slug": "sum",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Most used",
    "related": [
      "subtotal",
      "sumif",
      "sumifs",
      "sumproduct"
    ]
  },
  {
    "category": "calculate",
    "usage": "most-common",
    "name": "SUMIF",
    "description": "Adds values that meet one condition.",
    "syntax": "SUMIF(range, criteria, [sum_range])",
    "example": "=SUMIF(B2:B6,\"West\",C2:C6)",
    "result": "167,000",
    "version": "All versions",
    "note": "",
    "slug": "sumif",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Most used",
    "related": [
      "subtotal",
      "sum",
      "sumifs",
      "sumproduct"
    ]
  },
  {
    "category": "calculate",
    "usage": "most-common",
    "name": "SUMIFS",
    "description": "Adds values that meet multiple conditions.",
    "syntax": "SUMIFS(sum_range, criteria_range1, criteria1, …)",
    "example": "=SUMIFS(C2:C6,B2:B6,\"West\",E2:E6,\"Closed\")",
    "result": "167,000",
    "version": "All versions",
    "note": "",
    "slug": "sumifs",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Most used",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumproduct"
    ]
  },
  {
    "category": "calculate",
    "usage": "common",
    "name": "PRODUCT",
    "description": "Multiplies supplied numbers together.",
    "syntax": "PRODUCT(number1, [number2], …)",
    "example": "=PRODUCT(12.5,4)",
    "result": "50",
    "version": "All versions",
    "note": "",
    "slug": "product",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Common",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "most-common",
    "name": "SUMPRODUCT",
    "description": "Multiplies corresponding values and adds the results.",
    "syntax": "SUMPRODUCT(array1, [array2], …)",
    "example": "=SUMPRODUCT(C2:C6,D2:D6)",
    "result": "4,569,000",
    "version": "All versions",
    "note": "",
    "slug": "sumproduct",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Most used",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "most-common",
    "name": "SUBTOTAL",
    "description": "Calculates a summary and can ignore filtered rows.",
    "syntax": "SUBTOTAL(function_num, ref1, [ref2], …)",
    "example": "=SUBTOTAL(9,C2:C6)",
    "result": "364,000",
    "version": "All versions",
    "note": "",
    "slug": "subtotal",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Most used",
    "related": [
      "sum",
      "sumif",
      "sumifs",
      "sumproduct"
    ]
  },
  {
    "category": "calculate",
    "usage": "specialized",
    "name": "AGGREGATE",
    "description": "Performs summary calculations while optionally ignoring hidden rows or errors.",
    "syntax": "AGGREGATE(function_num, options, array, [k])",
    "example": "=AGGREGATE(9,5,C2:C6)",
    "result": "364,000",
    "version": "Excel 2010+",
    "note": "",
    "slug": "aggregate",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Specialized",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "common",
    "name": "ABS",
    "description": "Returns a number without its positive or negative sign.",
    "syntax": "ABS(number)",
    "example": "=ABS(-18.4)",
    "result": "18.4",
    "version": "All versions",
    "note": "",
    "slug": "abs",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Common",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "common",
    "name": "MOD",
    "description": "Returns the remainder after division.",
    "syntax": "MOD(number, divisor)",
    "example": "=MOD(17,5)",
    "result": "2",
    "version": "All versions",
    "note": "",
    "slug": "mod",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Common",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "specialized",
    "name": "QUOTIENT",
    "description": "Returns the whole-number portion of a division.",
    "syntax": "QUOTIENT(numerator, denominator)",
    "example": "=QUOTIENT(17,5)",
    "result": "3",
    "version": "All versions",
    "note": "",
    "slug": "quotient",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Specialized",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "common",
    "name": "POWER",
    "description": "Raises a number to a specified power.",
    "syntax": "POWER(number, power)",
    "example": "=POWER(5,3)",
    "result": "125",
    "version": "All versions",
    "note": "",
    "slug": "power",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Common",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "common",
    "name": "SQRT",
    "description": "Returns the positive square root of a number.",
    "syntax": "SQRT(number)",
    "example": "=SQRT(144)",
    "result": "12",
    "version": "All versions",
    "note": "",
    "slug": "sqrt",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Common",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "specialized",
    "name": "SUMSQ",
    "description": "Returns the sum of the squares of supplied values.",
    "syntax": "SUMSQ(number1, [number2], …)",
    "example": "=SUMSQ(3,4)",
    "result": "25",
    "version": "All versions",
    "note": "",
    "slug": "sumsq",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Specialized",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "specialized",
    "name": "SERIESSUM",
    "description": "Returns the sum of a power series.",
    "syntax": "SERIESSUM(x, n, m, coefficients)",
    "example": "=SERIESSUM(2,0,1,{1,2,3})",
    "result": "17",
    "version": "All versions",
    "note": "",
    "slug": "seriessum",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Specialized",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "rarely-used",
    "name": "GCD",
    "description": "Returns the greatest common divisor of integers.",
    "syntax": "GCD(number1, [number2], …)",
    "example": "=GCD(24,36)",
    "result": "12",
    "version": "All versions",
    "note": "",
    "slug": "gcd",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Rarely used",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "rarely-used",
    "name": "LCM",
    "description": "Returns the least common multiple of integers.",
    "syntax": "LCM(number1, [number2], …)",
    "example": "=LCM(6,8)",
    "result": "24",
    "version": "All versions",
    "note": "",
    "slug": "lcm",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Rarely used",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "specialized",
    "name": "COMBIN",
    "description": "Returns the number of combinations for a given number of items.",
    "syntax": "COMBIN(number, number_chosen)",
    "example": "=COMBIN(10,3)",
    "result": "120",
    "version": "All versions",
    "note": "",
    "slug": "combin",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Specialized",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "calculate",
    "usage": "specialized",
    "name": "COMBINA",
    "description": "Returns combinations including repeated selections.",
    "syntax": "COMBINA(number, number_chosen)",
    "example": "=COMBINA(4,2)",
    "result": "10",
    "version": "Excel 2013+",
    "note": "",
    "slug": "combina",
    "categoryLabel": "Calculate totals & amounts",
    "categoryDescription": "Add, multiply, subtotal and calculate business values.",
    "usageLabel": "Specialized",
    "related": [
      "subtotal",
      "sum",
      "sumif",
      "sumifs"
    ]
  },
  {
    "category": "lookup",
    "usage": "most-common",
    "name": "XLOOKUP",
    "description": "Searches one range and returns the matching value from another.",
    "syntax": "XLOOKUP(lookup_value, lookup_array, return_array, [if_not_found], [match_mode], [search_mode])",
    "example": "=XLOOKUP(\"P103\",A2:A6,B2:B6,\"Not found\")",
    "result": "Keyboard",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "xlookup",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Most used",
    "related": [
      "index",
      "match",
      "vlookup",
      "choose"
    ]
  },
  {
    "category": "lookup",
    "usage": "most-common",
    "name": "VLOOKUP",
    "description": "Looks down the first column of a table and returns a value from another column.",
    "syntax": "VLOOKUP(lookup_value, table_array, col_index_num, [range_lookup])",
    "example": "=VLOOKUP(\"P104\",A2:E6,3,FALSE)",
    "result": "8,900",
    "version": "All versions",
    "note": "",
    "slug": "vlookup",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Most used",
    "related": [
      "index",
      "match",
      "xlookup",
      "choose"
    ]
  },
  {
    "category": "lookup",
    "usage": "specialized",
    "name": "HLOOKUP",
    "description": "Looks across the top row of a table and returns a value from another row.",
    "syntax": "HLOOKUP(lookup_value, table_array, row_index_num, [range_lookup])",
    "example": "=HLOOKUP(\"Price\",A1:E6,4,FALSE)",
    "result": "18,500",
    "version": "All versions",
    "note": "",
    "slug": "hlookup",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Specialized",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "rarely-used",
    "name": "LOOKUP",
    "description": "Searches a one-row or one-column range and returns a corresponding value.",
    "syntax": "LOOKUP(lookup_value, lookup_vector, [result_vector])",
    "example": "=LOOKUP(\"P103\",A2:A6,B2:B6)",
    "result": "Keyboard",
    "version": "All versions",
    "note": "",
    "slug": "lookup",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Rarely used",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "most-common",
    "name": "INDEX",
    "description": "Returns the value at a specified row and column in a range.",
    "syntax": "INDEX(array, row_num, [column_num])",
    "example": "=INDEX(B2:E6,3,1)",
    "result": "Keyboard",
    "version": "All versions",
    "note": "",
    "slug": "index",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Most used",
    "related": [
      "match",
      "vlookup",
      "xlookup",
      "choose"
    ]
  },
  {
    "category": "lookup",
    "usage": "most-common",
    "name": "MATCH",
    "description": "Returns the relative position of a value in a range.",
    "syntax": "MATCH(lookup_value, lookup_array, [match_type])",
    "example": "=MATCH(\"P104\",A2:A6,0)",
    "result": "4",
    "version": "All versions",
    "note": "",
    "slug": "match",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Most used",
    "related": [
      "index",
      "vlookup",
      "xlookup",
      "choose"
    ]
  },
  {
    "category": "lookup",
    "usage": "common",
    "name": "XMATCH",
    "description": "Returns the position of a value with modern matching and search options.",
    "syntax": "XMATCH(lookup_value, lookup_array, [match_mode], [search_mode])",
    "example": "=XMATCH(\"P104\",A2:A6)",
    "result": "4",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "xmatch",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Common",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "common",
    "name": "CHOOSE",
    "description": "Returns an item from a list according to an index number.",
    "syntax": "CHOOSE(index_num, value1, [value2], …)",
    "example": "=CHOOSE(2,\"Low\",\"Medium\",\"High\")",
    "result": "Medium",
    "version": "All versions",
    "note": "",
    "slug": "choose",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Common",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "specialized",
    "name": "OFFSET",
    "description": "Returns a reference shifted by a selected number of rows and columns.",
    "syntax": "OFFSET(reference, rows, cols, [height], [width])",
    "example": "=SUM(OFFSET(C2,0,0,3,1))",
    "result": "235,000",
    "version": "All versions",
    "note": "OFFSET is volatile and may slow very large workbooks.",
    "slug": "offset",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Specialized",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "specialized",
    "name": "INDIRECT",
    "description": "Creates a cell or range reference from text.",
    "syntax": "INDIRECT(ref_text, [a1])",
    "example": "=INDIRECT(\"C2\")",
    "result": "250,000",
    "version": "All versions",
    "note": "INDIRECT is volatile and does not work with closed external workbooks.",
    "slug": "indirect",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Specialized",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "specialized",
    "name": "FORMULATEXT",
    "description": "Returns another cell’s formula as text.",
    "syntax": "FORMULATEXT(reference)",
    "example": "=FORMULATEXT(F2)",
    "result": "=XLOOKUP(\"P103\",A2:A6,B2:B6)",
    "version": "Excel 2013+",
    "note": "",
    "slug": "formulatext",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Specialized",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "common",
    "name": "TAKE",
    "description": "Returns selected rows or columns from the beginning or end of an array.",
    "syntax": "TAKE(array, rows, [columns])",
    "example": "=TAKE(A2:E6,2)",
    "result": "First 2 rows",
    "version": "Microsoft 365",
    "note": "",
    "slug": "take",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Common",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "common",
    "name": "DROP",
    "description": "Removes selected rows or columns from the beginning or end of an array.",
    "syntax": "DROP(array, rows, [columns])",
    "example": "=DROP(A2:E6,1)",
    "result": "Rows 2–5",
    "version": "Microsoft 365",
    "note": "",
    "slug": "drop",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Common",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "lookup",
    "usage": "specialized",
    "name": "GETPIVOTDATA",
    "description": "Returns a specific value from a PivotTable.",
    "syntax": "GETPIVOTDATA(data_field, pivot_table, [field1, item1], …)",
    "example": "=GETPIVOTDATA(\"Sales\",$A$3,\"Region\",\"West\")",
    "result": "167,000",
    "version": "All versions",
    "note": "",
    "slug": "getpivotdata",
    "categoryLabel": "Look up & retrieve data",
    "categoryDescription": "Find records and return related values from tables.",
    "usageLabel": "Specialized",
    "related": [
      "index",
      "match",
      "vlookup",
      "xlookup"
    ]
  },
  {
    "category": "logic",
    "usage": "most-common",
    "name": "IF",
    "description": "Returns one value when a condition is true and another when it is false.",
    "syntax": "IF(logical_test, value_if_true, value_if_false)",
    "example": "=IF(C2>=100000,\"Target Met\",\"Below Target\")",
    "result": "Target Met",
    "version": "All versions",
    "note": "",
    "slug": "if",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Most used",
    "related": [
      "and",
      "iferror",
      "or",
      "ifna"
    ]
  },
  {
    "category": "logic",
    "usage": "common",
    "name": "IFS",
    "description": "Tests multiple conditions and returns the first matching result.",
    "syntax": "IFS(logical_test1, value_if_true1, …)",
    "example": "=IFS(C2>=100000,\"High\",C2>=50000,\"Medium\",TRUE,\"Low\")",
    "result": "High",
    "version": "Excel 2019+",
    "note": "",
    "slug": "ifs",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Common",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "most-common",
    "name": "AND",
    "description": "Returns TRUE only when every supplied condition is true.",
    "syntax": "AND(logical1, [logical2], …)",
    "example": "=AND(C2>=100000,E2=\"Closed\")",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "and",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Most used",
    "related": [
      "if",
      "iferror",
      "or",
      "ifna"
    ]
  },
  {
    "category": "logic",
    "usage": "most-common",
    "name": "OR",
    "description": "Returns TRUE when at least one condition is true.",
    "syntax": "OR(logical1, [logical2], …)",
    "example": "=OR(B2=\"West\",B2=\"East\")",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "or",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Most used",
    "related": [
      "and",
      "if",
      "iferror",
      "ifna"
    ]
  },
  {
    "category": "logic",
    "usage": "common",
    "name": "NOT",
    "description": "Reverses a logical result.",
    "syntax": "NOT(logical)",
    "example": "=NOT(E2=\"Open\")",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "not",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Common",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "specialized",
    "name": "XOR",
    "description": "Returns TRUE when an odd number of supplied conditions are true.",
    "syntax": "XOR(logical1, [logical2], …)",
    "example": "=XOR(B2=\"West\",E2=\"Open\")",
    "result": "TRUE",
    "version": "Excel 2013+",
    "note": "",
    "slug": "xor",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Specialized",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "common",
    "name": "SWITCH",
    "description": "Matches an expression against several values and returns the related result.",
    "syntax": "SWITCH(expression, value1, result1, [default])",
    "example": "=SWITCH(E2,\"Closed\",\"Complete\",\"Open\",\"Pending\",\"Check\")",
    "result": "Complete",
    "version": "Excel 2019+",
    "note": "",
    "slug": "switch",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Common",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "most-common",
    "name": "IFERROR",
    "description": "Returns an alternative value when a formula produces any error.",
    "syntax": "IFERROR(value, value_if_error)",
    "example": "=IFERROR(VLOOKUP(\"P999\",A2:E6,2,FALSE),\"Not found\")",
    "result": "Not found",
    "version": "All versions",
    "note": "",
    "slug": "iferror",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Most used",
    "related": [
      "and",
      "if",
      "or",
      "ifna"
    ]
  },
  {
    "category": "logic",
    "usage": "common",
    "name": "IFNA",
    "description": "Returns an alternative value only when a formula produces #N/A.",
    "syntax": "IFNA(value, value_if_na)",
    "example": "=IFNA(XLOOKUP(\"P999\",A2:A6,B2:B6),\"Not found\")",
    "result": "Not found",
    "version": "Excel 2013+",
    "note": "",
    "slug": "ifna",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Common",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "rarely-used",
    "name": "TRUE",
    "description": "Returns the logical value TRUE.",
    "syntax": "TRUE()",
    "example": "=TRUE()",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "true",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Rarely used",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "rarely-used",
    "name": "FALSE",
    "description": "Returns the logical value FALSE.",
    "syntax": "FALSE()",
    "example": "=FALSE()",
    "result": "FALSE",
    "version": "All versions",
    "note": "",
    "slug": "false",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Rarely used",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "common",
    "name": "LET",
    "description": "Assigns names to intermediate calculations inside a formula.",
    "syntax": "LET(name1, name_value1, calculation)",
    "example": "=LET(total,SUM(C2:C6),total*5%)",
    "result": "18,200",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "let",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Common",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "specialized",
    "name": "LAMBDA",
    "description": "Creates a reusable custom function without VBA.",
    "syntax": "LAMBDA([parameter1, …], calculation)",
    "example": "=LAMBDA(x,x*1.18)(100)",
    "result": "118",
    "version": "Microsoft 365",
    "note": "",
    "slug": "lambda",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Specialized",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "logic",
    "usage": "specialized",
    "name": "BYROW",
    "description": "Applies a LAMBDA calculation to each row of an array.",
    "syntax": "BYROW(array, lambda(row))",
    "example": "=BYROW(C2:D6,LAMBDA(r,SUM(r)))",
    "result": "Row totals",
    "version": "Microsoft 365",
    "note": "",
    "slug": "byrow",
    "categoryLabel": "Make decisions & handle errors",
    "categoryDescription": "Test conditions, classify results and control formula errors.",
    "usageLabel": "Specialized",
    "related": [
      "and",
      "if",
      "iferror",
      "or"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "LEFT",
    "description": "Returns characters from the beginning of text.",
    "syntax": "LEFT(text, [num_chars])",
    "example": "=LEFT(\"SL-2026-015\",2)",
    "result": "SL",
    "version": "All versions",
    "note": "",
    "slug": "left",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "len",
      "mid",
      "right"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "RIGHT",
    "description": "Returns characters from the end of text.",
    "syntax": "RIGHT(text, [num_chars])",
    "example": "=RIGHT(\"SL-2026-015\",3)",
    "result": "015",
    "version": "All versions",
    "note": "",
    "slug": "right",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "MID",
    "description": "Returns characters from the middle of text.",
    "syntax": "MID(text, start_num, num_chars)",
    "example": "=MID(\"SL-2026-015\",4,4)",
    "result": "2026",
    "version": "All versions",
    "note": "",
    "slug": "mid",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "right"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "LEN",
    "description": "Counts characters in text, including spaces.",
    "syntax": "LEN(text)",
    "example": "=LEN(\"Excel Skills\")",
    "result": "12",
    "version": "All versions",
    "note": "",
    "slug": "len",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "mid",
      "right"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "TRIM",
    "description": "Removes leading, trailing and repeated ordinary spaces.",
    "syntax": "TRIM(text)",
    "example": "=TRIM(\"  Pramod  Fernando  \")",
    "result": "Pramod Fernando",
    "version": "All versions",
    "note": "",
    "slug": "trim",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "CLEAN",
    "description": "Removes many non-printing characters from text.",
    "syntax": "CLEAN(text)",
    "example": "=CLEAN(A2)",
    "result": "Cleaned text",
    "version": "All versions",
    "note": "",
    "slug": "clean",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "UPPER",
    "description": "Converts text to uppercase.",
    "syntax": "UPPER(text)",
    "example": "=UPPER(\"Excel\")",
    "result": "EXCEL",
    "version": "All versions",
    "note": "",
    "slug": "upper",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "LOWER",
    "description": "Converts text to lowercase.",
    "syntax": "LOWER(text)",
    "example": "=LOWER(\"EXCEL\")",
    "result": "excel",
    "version": "All versions",
    "note": "",
    "slug": "lower",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "PROPER",
    "description": "Capitalises the first letter of each word.",
    "syntax": "PROPER(text)",
    "example": "=PROPER(\"pramod fernando\")",
    "result": "Pramod Fernando",
    "version": "All versions",
    "note": "",
    "slug": "proper",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "CONCAT",
    "description": "Combines text values without automatically adding a delimiter.",
    "syntax": "CONCAT(text1, [text2], …)",
    "example": "=CONCAT(\"Mr \",\"Excel\")",
    "result": "Mr Excel",
    "version": "Excel 2019+",
    "note": "",
    "slug": "concat",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "left",
      "len",
      "mid",
      "right"
    ]
  },
  {
    "category": "text",
    "usage": "rarely-used",
    "name": "CONCATENATE",
    "description": "Combines separate text values into one string.",
    "syntax": "CONCATENATE(text1, [text2], …)",
    "example": "=CONCATENATE(\"Mr \",\"Excel\")",
    "result": "Mr Excel",
    "version": "Legacy",
    "note": "",
    "slug": "concatenate",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Rarely used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "TEXTJOIN",
    "description": "Combines text using a chosen delimiter and can ignore empty cells.",
    "syntax": "TEXTJOIN(delimiter, ignore_empty, text1, [text2], …)",
    "example": "=TEXTJOIN(\" | \",TRUE,\"Finance\",\"West\",\"Closed\")",
    "result": "Finance | West | Closed",
    "version": "Excel 2019+",
    "note": "",
    "slug": "textjoin",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "TEXTSPLIT",
    "description": "Splits text into columns or rows using delimiters.",
    "syntax": "TEXTSPLIT(text, col_delimiter, [row_delimiter], …)",
    "example": "=TEXTSPLIT(\"SL-2026-015\",\"-\")",
    "result": "SL | 2026 | 015",
    "version": "Microsoft 365",
    "note": "",
    "slug": "textsplit",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "TEXTBEFORE",
    "description": "Returns text before a selected delimiter.",
    "syntax": "TEXTBEFORE(text, delimiter, [instance_num], …)",
    "example": "=TEXTBEFORE(\"pramod@example.com\",\"@\")",
    "result": "pramod",
    "version": "Microsoft 365",
    "note": "",
    "slug": "textbefore",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "TEXTAFTER",
    "description": "Returns text after a selected delimiter.",
    "syntax": "TEXTAFTER(text, delimiter, [instance_num], …)",
    "example": "=TEXTAFTER(\"pramod@example.com\",\"@\")",
    "result": "example.com",
    "version": "Microsoft 365",
    "note": "",
    "slug": "textafter",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "FIND",
    "description": "Returns the position of text and is case-sensitive.",
    "syntax": "FIND(find_text, within_text, [start_num])",
    "example": "=FIND(\"-\",\"SL-2026-015\")",
    "result": "3",
    "version": "All versions",
    "note": "",
    "slug": "find",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "SEARCH",
    "description": "Returns the position of text and is not case-sensitive.",
    "syntax": "SEARCH(find_text, within_text, [start_num])",
    "example": "=SEARCH(\"excel\",\"Advanced Excel\")",
    "result": "10",
    "version": "All versions",
    "note": "",
    "slug": "search",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "REPLACE",
    "description": "Replaces characters according to their position.",
    "syntax": "REPLACE(old_text, start_num, num_chars, new_text)",
    "example": "=REPLACE(\"SL-2026-015\",4,4,\"2027\")",
    "result": "SL-2027-015",
    "version": "All versions",
    "note": "",
    "slug": "replace",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "SUBSTITUTE",
    "description": "Replaces matching text with new text.",
    "syntax": "SUBSTITUTE(text, old_text, new_text, [instance_num])",
    "example": "=SUBSTITUTE(\"Priority - High\",\"High\",\"Urgent\")",
    "result": "Priority - Urgent",
    "version": "All versions",
    "note": "",
    "slug": "substitute",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "VALUE",
    "description": "Converts a number stored as text into a numeric value.",
    "syntax": "VALUE(text)",
    "example": "=VALUE(\"1250\")",
    "result": "1,250",
    "version": "All versions",
    "note": "",
    "slug": "value",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "most-common",
    "name": "TEXT",
    "description": "Formats a number or date and returns it as text.",
    "syntax": "TEXT(value, format_text)",
    "example": "=TEXT(DATE(2026,6,18),\"dd-mmm-yyyy\")",
    "result": "18-Jun-2026",
    "version": "All versions",
    "note": "",
    "slug": "text",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Most used",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "specialized",
    "name": "EXACT",
    "description": "Compares two text values and is case-sensitive.",
    "syntax": "EXACT(text1, text2)",
    "example": "=EXACT(\"Excel\",\"EXCEL\")",
    "result": "FALSE",
    "version": "All versions",
    "note": "",
    "slug": "exact",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Specialized",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "specialized",
    "name": "REPT",
    "description": "Repeats text a specified number of times.",
    "syntax": "REPT(text, number_times)",
    "example": "=REPT(\"★\",5)",
    "result": "★★★★★",
    "version": "All versions",
    "note": "",
    "slug": "rept",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Specialized",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "specialized",
    "name": "CHAR",
    "description": "Returns the character represented by a code number.",
    "syntax": "CHAR(number)",
    "example": "=CHAR(65)",
    "result": "A",
    "version": "All versions",
    "note": "",
    "slug": "char",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Specialized",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "specialized",
    "name": "CODE",
    "description": "Returns the numeric code for the first character in text.",
    "syntax": "CODE(text)",
    "example": "=CODE(\"A\")",
    "result": "65",
    "version": "All versions",
    "note": "",
    "slug": "code",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Specialized",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "text",
    "usage": "common",
    "name": "DOLLAR",
    "description": "Converts a number to text using currency formatting.",
    "syntax": "DOLLAR(number, [decimals])",
    "example": "=DOLLAR(1250,2)",
    "result": "$1,250.00",
    "version": "All versions",
    "note": "",
    "slug": "dollar",
    "categoryLabel": "Clean, split & combine text",
    "categoryDescription": "Prepare names, codes and imported text for reporting.",
    "usageLabel": "Common",
    "related": [
      "concat",
      "left",
      "len",
      "mid"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "TODAY",
    "description": "Returns the current date.",
    "syntax": "TODAY()",
    "example": "=TODAY()",
    "result": "Current date",
    "version": "All versions",
    "note": "",
    "slug": "today",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "NOW",
    "description": "Returns the current date and time.",
    "syntax": "NOW()",
    "example": "=NOW()",
    "result": "Current date and time",
    "version": "All versions",
    "note": "",
    "slug": "now",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "DATE",
    "description": "Creates a valid Excel date from year, month and day values.",
    "syntax": "DATE(year, month, day)",
    "example": "=DATE(2026,6,18)",
    "result": "18-Jun-2026",
    "version": "All versions",
    "note": "",
    "slug": "date",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "TIME",
    "description": "Creates an Excel time from hour, minute and second values.",
    "syntax": "TIME(hour, minute, second)",
    "example": "=TIME(14,30,0)",
    "result": "2:30 PM",
    "version": "All versions",
    "note": "",
    "slug": "time",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "YEAR",
    "description": "Returns the year from a date.",
    "syntax": "YEAR(serial_number)",
    "example": "=YEAR(DATE(2026,6,18))",
    "result": "2026",
    "version": "All versions",
    "note": "",
    "slug": "year",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "MONTH",
    "description": "Returns the month number from a date.",
    "syntax": "MONTH(serial_number)",
    "example": "=MONTH(DATE(2026,6,18))",
    "result": "6",
    "version": "All versions",
    "note": "",
    "slug": "month",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "DAY",
    "description": "Returns the day of the month from a date.",
    "syntax": "DAY(serial_number)",
    "example": "=DAY(DATE(2026,6,18))",
    "result": "18",
    "version": "All versions",
    "note": "",
    "slug": "day",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "days",
      "eomonth",
      "month"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "HOUR",
    "description": "Returns the hour from a time value.",
    "syntax": "HOUR(serial_number)",
    "example": "=HOUR(TIME(14,30,0))",
    "result": "14",
    "version": "All versions",
    "note": "",
    "slug": "hour",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "MINUTE",
    "description": "Returns the minute from a time value.",
    "syntax": "MINUTE(serial_number)",
    "example": "=MINUTE(TIME(14,30,0))",
    "result": "30",
    "version": "All versions",
    "note": "",
    "slug": "minute",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "SECOND",
    "description": "Returns the second from a time value.",
    "syntax": "SECOND(serial_number)",
    "example": "=SECOND(TIME(14,30,45))",
    "result": "45",
    "version": "All versions",
    "note": "",
    "slug": "second",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "DATEDIF",
    "description": "Calculates complete years, months or days between two dates.",
    "syntax": "DATEDIF(start_date, end_date, unit)",
    "example": "=DATEDIF(DATE(2020,1,1),DATE(2026,6,18),\"Y\")",
    "result": "6",
    "version": "All versions",
    "note": "DATEDIF is retained for compatibility and may not appear in Formula AutoComplete.",
    "slug": "datedif",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "day",
      "days",
      "eomonth",
      "month"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "DAYS",
    "description": "Returns the number of days between two dates.",
    "syntax": "DAYS(end_date, start_date)",
    "example": "=DAYS(DATE(2026,6,18),DATE(2026,6,1))",
    "result": "17",
    "version": "Excel 2013+",
    "note": "",
    "slug": "days",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "eomonth",
      "month"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "NETWORKDAYS",
    "description": "Counts working days between two dates.",
    "syntax": "NETWORKDAYS(start_date, end_date, [holidays])",
    "example": "=NETWORKDAYS(DATE(2026,6,1),DATE(2026,6,18))",
    "result": "14",
    "version": "All versions",
    "note": "",
    "slug": "networkdays",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "NETWORKDAYS.INTL",
    "description": "Counts working days using a custom weekend pattern.",
    "syntax": "NETWORKDAYS.INTL(start_date, end_date, [weekend], [holidays])",
    "example": "=NETWORKDAYS.INTL(DATE(2026,6,1),DATE(2026,6,18),1)",
    "result": "14",
    "version": "Excel 2010+",
    "note": "",
    "slug": "networkdays-intl",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "WORKDAY",
    "description": "Returns a working date before or after a starting date.",
    "syntax": "WORKDAY(start_date, days, [holidays])",
    "example": "=WORKDAY(DATE(2026,6,18),10)",
    "result": "02-Jul-2026",
    "version": "All versions",
    "note": "",
    "slug": "workday",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "WORKDAY.INTL",
    "description": "Returns a working date using a custom weekend pattern.",
    "syntax": "WORKDAY.INTL(start_date, days, [weekend], [holidays])",
    "example": "=WORKDAY.INTL(DATE(2026,6,18),10,1)",
    "result": "02-Jul-2026",
    "version": "Excel 2010+",
    "note": "",
    "slug": "workday-intl",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "most-common",
    "name": "EOMONTH",
    "description": "Returns the final date of a month before or after a selected date.",
    "syntax": "EOMONTH(start_date, months)",
    "example": "=EOMONTH(DATE(2026,6,18),0)",
    "result": "30-Jun-2026",
    "version": "All versions",
    "note": "",
    "slug": "eomonth",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Most used",
    "related": [
      "datedif",
      "day",
      "days",
      "month"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "EDATE",
    "description": "Returns a date a selected number of months before or after another date.",
    "syntax": "EDATE(start_date, months)",
    "example": "=EDATE(DATE(2026,6,18),3)",
    "result": "18-Sep-2026",
    "version": "All versions",
    "note": "",
    "slug": "edate",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "WEEKDAY",
    "description": "Returns the weekday number for a date.",
    "syntax": "WEEKDAY(serial_number, [return_type])",
    "example": "=WEEKDAY(DATE(2026,6,18),2)",
    "result": "4",
    "version": "All versions",
    "note": "",
    "slug": "weekday",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "common",
    "name": "WEEKNUM",
    "description": "Returns the week number for a date.",
    "syntax": "WEEKNUM(serial_number, [return_type])",
    "example": "=WEEKNUM(DATE(2026,6,18),2)",
    "result": "25",
    "version": "All versions",
    "note": "",
    "slug": "weeknum",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Common",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "specialized",
    "name": "ISOWEEKNUM",
    "description": "Returns the ISO week number for a date.",
    "syntax": "ISOWEEKNUM(date)",
    "example": "=ISOWEEKNUM(DATE(2026,6,18))",
    "result": "25",
    "version": "Excel 2013+",
    "note": "",
    "slug": "isoweeknum",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Specialized",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "specialized",
    "name": "YEARFRAC",
    "description": "Returns the fraction of a year between two dates.",
    "syntax": "YEARFRAC(start_date, end_date, [basis])",
    "example": "=YEARFRAC(DATE(2026,1,1),DATE(2026,6,30))",
    "result": "0.49",
    "version": "All versions",
    "note": "",
    "slug": "yearfrac",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Specialized",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "specialized",
    "name": "DAYS360",
    "description": "Calculates days between two dates using a 360-day year.",
    "syntax": "DAYS360(start_date, end_date, [method])",
    "example": "=DAYS360(DATE(2026,1,1),DATE(2026,6,30))",
    "result": "179",
    "version": "All versions",
    "note": "",
    "slug": "days360",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Specialized",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "date",
    "usage": "specialized",
    "name": "DATEVALUE",
    "description": "Converts a date stored as text into an Excel date number.",
    "syntax": "DATEVALUE(date_text)",
    "example": "=DATEVALUE(\"18-Jun-2026\")",
    "result": "18-Jun-2026",
    "version": "All versions",
    "note": "",
    "slug": "datevalue",
    "categoryLabel": "Work with dates & schedules",
    "categoryDescription": "Calculate deadlines, working days, periods and time values.",
    "usageLabel": "Specialized",
    "related": [
      "datedif",
      "day",
      "days",
      "eomonth"
    ]
  },
  {
    "category": "array",
    "usage": "most-common",
    "name": "FILTER",
    "description": "Returns only rows or columns that meet selected conditions.",
    "syntax": "FILTER(array, include, [if_empty])",
    "example": "=FILTER(A2:E6,E2:E6=\"Closed\",\"No records\")",
    "result": "Matching rows",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "filter",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Most used",
    "related": [
      "sort",
      "unique",
      "hstack",
      "randarray"
    ]
  },
  {
    "category": "array",
    "usage": "most-common",
    "name": "UNIQUE",
    "description": "Returns distinct values from a range or array.",
    "syntax": "UNIQUE(array, [by_col], [exactly_once])",
    "example": "=UNIQUE(B2:B6)",
    "result": "Unique regions",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "unique",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Most used",
    "related": [
      "filter",
      "sort",
      "hstack",
      "randarray"
    ]
  },
  {
    "category": "array",
    "usage": "most-common",
    "name": "SORT",
    "description": "Sorts an array by a selected row or column.",
    "syntax": "SORT(array, [sort_index], [sort_order], [by_col])",
    "example": "=SORT(A2:E6,3,-1)",
    "result": "Sorted by sales",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "sort",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Most used",
    "related": [
      "filter",
      "unique",
      "hstack",
      "randarray"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "SORTBY",
    "description": "Sorts an array using values from another range or array.",
    "syntax": "SORTBY(array, by_array1, [sort_order1], …)",
    "example": "=SORTBY(A2:E6,C2:C6,-1)",
    "result": "Sorted by sales",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "sortby",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "SEQUENCE",
    "description": "Creates a sequence of numbers in rows and columns.",
    "syntax": "SEQUENCE(rows, [columns], [start], [step])",
    "example": "=SEQUENCE(5,1,1,1)",
    "result": "1, 2, 3, 4, 5",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "sequence",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "RANDARRAY",
    "description": "Creates an array of random numbers.",
    "syntax": "RANDARRAY([rows], [columns], [min], [max], [whole_number])",
    "example": "=RANDARRAY(5,1,1,100,TRUE)",
    "result": "Five random integers",
    "version": "Microsoft 365 / Excel 2021+",
    "note": "",
    "slug": "randarray",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "specialized",
    "name": "TRANSPOSE",
    "description": "Changes rows into columns or columns into rows.",
    "syntax": "TRANSPOSE(array)",
    "example": "=TRANSPOSE(A2:E6)",
    "result": "Transposed range",
    "version": "All versions",
    "note": "",
    "slug": "transpose",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Specialized",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "TOCOL",
    "description": "Returns an array as a single column.",
    "syntax": "TOCOL(array, [ignore], [scan_by_column])",
    "example": "=TOCOL(A2:C4,1)",
    "result": "One-column list",
    "version": "Microsoft 365",
    "note": "",
    "slug": "tocol",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "TOROW",
    "description": "Returns an array as a single row.",
    "syntax": "TOROW(array, [ignore], [scan_by_column])",
    "example": "=TOROW(A2:C4,1)",
    "result": "One-row list",
    "version": "Microsoft 365",
    "note": "",
    "slug": "torow",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "WRAPROWS",
    "description": "Wraps a vector into rows after a selected number of values.",
    "syntax": "WRAPROWS(vector, wrap_count, [pad_with])",
    "example": "=WRAPROWS(A2:A7,3)",
    "result": "2 × 3 array",
    "version": "Microsoft 365",
    "note": "",
    "slug": "wraprows",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "WRAPCOLS",
    "description": "Wraps a vector into columns after a selected number of values.",
    "syntax": "WRAPCOLS(vector, wrap_count, [pad_with])",
    "example": "=WRAPCOLS(A2:A7,3)",
    "result": "3 × 2 array",
    "version": "Microsoft 365",
    "note": "",
    "slug": "wrapcols",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "VSTACK",
    "description": "Appends arrays vertically.",
    "syntax": "VSTACK(array1, [array2], …)",
    "example": "=VSTACK(A2:C4,A7:C9)",
    "result": "Combined rows",
    "version": "Microsoft 365",
    "note": "",
    "slug": "vstack",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "common",
    "name": "HSTACK",
    "description": "Appends arrays horizontally.",
    "syntax": "HSTACK(array1, [array2], …)",
    "example": "=HSTACK(A2:B6,D2:E6)",
    "result": "Combined columns",
    "version": "Microsoft 365",
    "note": "",
    "slug": "hstack",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Common",
    "related": [
      "filter",
      "sort",
      "unique",
      "randarray"
    ]
  },
  {
    "category": "array",
    "usage": "specialized",
    "name": "CHOOSECOLS",
    "description": "Returns selected columns from an array.",
    "syntax": "CHOOSECOLS(array, col_num1, [col_num2], …)",
    "example": "=CHOOSECOLS(A2:E6,1,3,5)",
    "result": "Columns 1, 3 and 5",
    "version": "Microsoft 365",
    "note": "",
    "slug": "choosecols",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Specialized",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "specialized",
    "name": "CHOOSEROWS",
    "description": "Returns selected rows from an array.",
    "syntax": "CHOOSEROWS(array, row_num1, [row_num2], …)",
    "example": "=CHOOSEROWS(A2:E6,1,3,5)",
    "result": "Rows 1, 3 and 5",
    "version": "Microsoft 365",
    "note": "",
    "slug": "chooserows",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Specialized",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "specialized",
    "name": "EXPAND",
    "description": "Expands an array to selected dimensions and fills added cells.",
    "syntax": "EXPAND(array, rows, [columns], [pad_with])",
    "example": "=EXPAND(A2:B3,5,3,0)",
    "result": "5 × 3 array",
    "version": "Microsoft 365",
    "note": "",
    "slug": "expand",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Specialized",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "specialized",
    "name": "MAKEARRAY",
    "description": "Creates a calculated array using a LAMBDA formula.",
    "syntax": "MAKEARRAY(rows, columns, lambda(row, column))",
    "example": "=MAKEARRAY(3,3,LAMBDA(r,c,r*c))",
    "result": "Multiplication grid",
    "version": "Microsoft 365",
    "note": "",
    "slug": "makearray",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Specialized",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "array",
    "usage": "specialized",
    "name": "REDUCE",
    "description": "Accumulates a calculation across an array and returns one result.",
    "syntax": "REDUCE([initial_value], array, lambda(accumulator, value, body))",
    "example": "=REDUCE(0,C2:C6,LAMBDA(a,v,a+v))",
    "result": "364,000",
    "version": "Microsoft 365",
    "note": "",
    "slug": "reduce",
    "categoryLabel": "Filter, sort & reshape lists",
    "categoryDescription": "Create dynamic reports and transform ranges with modern arrays.",
    "usageLabel": "Specialized",
    "related": [
      "filter",
      "sort",
      "unique",
      "hstack"
    ]
  },
  {
    "category": "round",
    "usage": "most-common",
    "name": "ROUND",
    "description": "Rounds a number to a selected number of digits.",
    "syntax": "ROUND(number, num_digits)",
    "example": "=ROUND(12.675,2)",
    "result": "12.68",
    "version": "All versions",
    "note": "",
    "slug": "round",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Most used",
    "related": [
      "ceiling-math",
      "floor-math",
      "int",
      "mround"
    ]
  },
  {
    "category": "round",
    "usage": "common",
    "name": "ROUNDUP",
    "description": "Rounds a number away from zero.",
    "syntax": "ROUNDUP(number, num_digits)",
    "example": "=ROUNDUP(12.671,2)",
    "result": "12.68",
    "version": "All versions",
    "note": "",
    "slug": "roundup",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Common",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "round",
    "usage": "common",
    "name": "ROUNDDOWN",
    "description": "Rounds a number toward zero.",
    "syntax": "ROUNDDOWN(number, num_digits)",
    "example": "=ROUNDDOWN(12.679,2)",
    "result": "12.67",
    "version": "All versions",
    "note": "",
    "slug": "rounddown",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Common",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "round",
    "usage": "common",
    "name": "MROUND",
    "description": "Rounds a number to the nearest selected multiple.",
    "syntax": "MROUND(number, multiple)",
    "example": "=MROUND(127,5)",
    "result": "125",
    "version": "All versions",
    "note": "",
    "slug": "mround",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Common",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "round",
    "usage": "common",
    "name": "CEILING.MATH",
    "description": "Rounds a number up to a selected multiple.",
    "syntax": "CEILING.MATH(number, [significance], [mode])",
    "example": "=CEILING.MATH(127,5)",
    "result": "130",
    "version": "Excel 2013+",
    "note": "",
    "slug": "ceiling-math",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Common",
    "related": [
      "round",
      "floor-math",
      "int",
      "mround"
    ]
  },
  {
    "category": "round",
    "usage": "common",
    "name": "FLOOR.MATH",
    "description": "Rounds a number down to a selected multiple.",
    "syntax": "FLOOR.MATH(number, [significance], [mode])",
    "example": "=FLOOR.MATH(127,5)",
    "result": "125",
    "version": "Excel 2013+",
    "note": "",
    "slug": "floor-math",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Common",
    "related": [
      "round",
      "ceiling-math",
      "int",
      "mround"
    ]
  },
  {
    "category": "round",
    "usage": "specialized",
    "name": "CEILING.PRECISE",
    "description": "Rounds a number up regardless of its sign.",
    "syntax": "CEILING.PRECISE(number, [significance])",
    "example": "=CEILING.PRECISE(-12.3,1)",
    "result": "-12",
    "version": "Excel 2010+",
    "note": "",
    "slug": "ceiling-precise",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Specialized",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "round",
    "usage": "specialized",
    "name": "FLOOR.PRECISE",
    "description": "Rounds a number down regardless of its sign.",
    "syntax": "FLOOR.PRECISE(number, [significance])",
    "example": "=FLOOR.PRECISE(-12.3,1)",
    "result": "-13",
    "version": "Excel 2010+",
    "note": "",
    "slug": "floor-precise",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Specialized",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "round",
    "usage": "common",
    "name": "INT",
    "description": "Rounds a number down to the nearest integer.",
    "syntax": "INT(number)",
    "example": "=INT(12.9)",
    "result": "12",
    "version": "All versions",
    "note": "",
    "slug": "int",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Common",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "mround"
    ]
  },
  {
    "category": "round",
    "usage": "common",
    "name": "TRUNC",
    "description": "Removes decimal places without rounding.",
    "syntax": "TRUNC(number, [num_digits])",
    "example": "=TRUNC(12.679,2)",
    "result": "12.67",
    "version": "All versions",
    "note": "",
    "slug": "trunc",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Common",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "round",
    "usage": "specialized",
    "name": "EVEN",
    "description": "Rounds a number away from zero to the nearest even integer.",
    "syntax": "EVEN(number)",
    "example": "=EVEN(7)",
    "result": "8",
    "version": "All versions",
    "note": "",
    "slug": "even",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Specialized",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "round",
    "usage": "specialized",
    "name": "ODD",
    "description": "Rounds a number away from zero to the nearest odd integer.",
    "syntax": "ODD(number)",
    "example": "=ODD(8)",
    "result": "9",
    "version": "All versions",
    "note": "",
    "slug": "odd",
    "categoryLabel": "Round & control numbers",
    "categoryDescription": "Control precision, signs, remainders and numeric presentation.",
    "usageLabel": "Specialized",
    "related": [
      "round",
      "ceiling-math",
      "floor-math",
      "int"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "AVERAGE",
    "description": "Returns the arithmetic mean of numbers.",
    "syntax": "AVERAGE(number1, [number2], …)",
    "example": "=AVERAGE(C2:C6)",
    "result": "72,800",
    "version": "All versions",
    "note": "",
    "slug": "average",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "averageif",
      "averageifs",
      "count",
      "counta"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "AVERAGEIF",
    "description": "Averages values that meet one condition.",
    "syntax": "AVERAGEIF(range, criteria, [average_range])",
    "example": "=AVERAGEIF(B2:B6,\"West\",C2:C6)",
    "result": "83,500",
    "version": "All versions",
    "note": "",
    "slug": "averageif",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageifs",
      "count",
      "counta"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "AVERAGEIFS",
    "description": "Averages values that meet multiple conditions.",
    "syntax": "AVERAGEIFS(average_range, criteria_range1, criteria1, …)",
    "example": "=AVERAGEIFS(C2:C6,B2:B6,\"West\",E2:E6,\"Closed\")",
    "result": "83,500",
    "version": "All versions",
    "note": "",
    "slug": "averageifs",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "count",
      "counta"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "COUNT",
    "description": "Counts cells containing numbers.",
    "syntax": "COUNT(value1, [value2], …)",
    "example": "=COUNT(C2:C6)",
    "result": "5",
    "version": "All versions",
    "note": "",
    "slug": "count",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "counta"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "COUNTA",
    "description": "Counts nonblank cells.",
    "syntax": "COUNTA(value1, [value2], …)",
    "example": "=COUNTA(A2:A6)",
    "result": "5",
    "version": "All versions",
    "note": "",
    "slug": "counta",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "COUNTBLANK",
    "description": "Counts blank cells in a range.",
    "syntax": "COUNTBLANK(range)",
    "example": "=COUNTBLANK(E2:E10)",
    "result": "3",
    "version": "All versions",
    "note": "",
    "slug": "countblank",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "COUNTIF",
    "description": "Counts cells that meet one condition.",
    "syntax": "COUNTIF(range, criteria)",
    "example": "=COUNTIF(B2:B6,\"West\")",
    "result": "2",
    "version": "All versions",
    "note": "",
    "slug": "countif",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "COUNTIFS",
    "description": "Counts records that meet multiple conditions.",
    "syntax": "COUNTIFS(criteria_range1, criteria1, …)",
    "example": "=COUNTIFS(B2:B6,\"West\",E2:E6,\"Closed\")",
    "result": "2",
    "version": "All versions",
    "note": "",
    "slug": "countifs",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "MAX",
    "description": "Returns the largest value.",
    "syntax": "MAX(number1, [number2], …)",
    "example": "=MAX(C2:C6)",
    "result": "125,000",
    "version": "All versions",
    "note": "",
    "slug": "max",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "most-common",
    "name": "MIN",
    "description": "Returns the smallest value.",
    "syntax": "MIN(number1, [number2], …)",
    "example": "=MIN(C2:C6)",
    "result": "31,000",
    "version": "All versions",
    "note": "",
    "slug": "min",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Most used",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "common",
    "name": "MAXIFS",
    "description": "Returns the largest value that meets conditions.",
    "syntax": "MAXIFS(max_range, criteria_range1, criteria1, …)",
    "example": "=MAXIFS(C2:C6,B2:B6,\"West\")",
    "result": "125,000",
    "version": "Excel 2019+",
    "note": "",
    "slug": "maxifs",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Common",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "common",
    "name": "MINIFS",
    "description": "Returns the smallest value that meets conditions.",
    "syntax": "MINIFS(min_range, criteria_range1, criteria1, …)",
    "example": "=MINIFS(C2:C6,B2:B6,\"West\")",
    "result": "42,000",
    "version": "Excel 2019+",
    "note": "",
    "slug": "minifs",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Common",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "common",
    "name": "MEDIAN",
    "description": "Returns the middle value in a numeric set.",
    "syntax": "MEDIAN(number1, [number2], …)",
    "example": "=MEDIAN(C2:C6)",
    "result": "68,000",
    "version": "All versions",
    "note": "",
    "slug": "median",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Common",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "MODE.SNGL",
    "description": "Returns the most frequently occurring value.",
    "syntax": "MODE.SNGL(number1, [number2], …)",
    "example": "=MODE.SNGL({2,3,3,4,5})",
    "result": "3",
    "version": "Excel 2010+",
    "note": "",
    "slug": "mode-sngl",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "common",
    "name": "LARGE",
    "description": "Returns the k-th largest value.",
    "syntax": "LARGE(array, k)",
    "example": "=LARGE(C2:C6,2)",
    "result": "98,000",
    "version": "All versions",
    "note": "",
    "slug": "large",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Common",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "common",
    "name": "SMALL",
    "description": "Returns the k-th smallest value.",
    "syntax": "SMALL(array, k)",
    "example": "=SMALL(C2:C6,2)",
    "result": "42,000",
    "version": "All versions",
    "note": "",
    "slug": "small",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Common",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "common",
    "name": "RANK.EQ",
    "description": "Returns a value’s rank in a list.",
    "syntax": "RANK.EQ(number, ref, [order])",
    "example": "=RANK.EQ(C2,C2:C6,0)",
    "result": "1",
    "version": "Excel 2010+",
    "note": "",
    "slug": "rank-eq",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Common",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "PERCENTILE.INC",
    "description": "Returns a value at a selected percentile, including endpoints.",
    "syntax": "PERCENTILE.INC(array, k)",
    "example": "=PERCENTILE.INC(C2:C6,0.9)",
    "result": "114,200",
    "version": "Excel 2010+",
    "note": "",
    "slug": "percentile-inc",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "QUARTILE.INC",
    "description": "Returns a selected quartile, including endpoints.",
    "syntax": "QUARTILE.INC(array, quart)",
    "example": "=QUARTILE.INC(C2:C6,1)",
    "result": "42,000",
    "version": "Excel 2010+",
    "note": "",
    "slug": "quartile-inc",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "STDEV.S",
    "description": "Estimates standard deviation from a sample.",
    "syntax": "STDEV.S(number1, [number2], …)",
    "example": "=STDEV.S(C2:C6)",
    "result": "39,627",
    "version": "Excel 2010+",
    "note": "",
    "slug": "stdev-s",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "STDEV.P",
    "description": "Returns standard deviation for a full population.",
    "syntax": "STDEV.P(number1, [number2], …)",
    "example": "=STDEV.P(C2:C6)",
    "result": "35,443",
    "version": "Excel 2010+",
    "note": "",
    "slug": "stdev-p",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "VAR.S",
    "description": "Estimates variance from a sample.",
    "syntax": "VAR.S(number1, [number2], …)",
    "example": "=VAR.S(C2:C6)",
    "result": "1,570,700,000",
    "version": "Excel 2010+",
    "note": "",
    "slug": "var-s",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "CORREL",
    "description": "Returns the correlation coefficient between two data sets.",
    "syntax": "CORREL(array1, array2)",
    "example": "=CORREL(C2:C6,D2:D6)",
    "result": "-0.89",
    "version": "All versions",
    "note": "",
    "slug": "correl",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "statistics",
    "usage": "specialized",
    "name": "FORECAST.LINEAR",
    "description": "Predicts a value using linear regression.",
    "syntax": "FORECAST.LINEAR(x, known_y’s, known_x’s)",
    "example": "=FORECAST.LINEAR(6,C2:C6,D2:D6)",
    "result": "Forecast result",
    "version": "Excel 2016+",
    "note": "",
    "slug": "forecast-linear",
    "categoryLabel": "Analyse data statistically",
    "categoryDescription": "Summarise distributions, rankings, relationships and trends.",
    "usageLabel": "Specialized",
    "related": [
      "average",
      "averageif",
      "averageifs",
      "count"
    ]
  },
  {
    "category": "financial",
    "usage": "most-common",
    "name": "PMT",
    "description": "Calculates the periodic payment for a loan or investment.",
    "syntax": "PMT(rate, nper, pv, [fv], [type])",
    "example": "=PMT(12%/12,60,-1000000)",
    "result": "22,244",
    "version": "All versions",
    "note": "",
    "slug": "pmt",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Most used",
    "related": [
      "fv",
      "ipmt",
      "irr",
      "nper"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "PV",
    "description": "Returns the present value of future cash flows.",
    "syntax": "PV(rate, nper, pmt, [fv], [type])",
    "example": "=PV(10%/12,48,-12682)",
    "result": "500,000",
    "version": "All versions",
    "note": "",
    "slug": "pv",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "FV",
    "description": "Returns the future value of an investment.",
    "syntax": "FV(rate, nper, pmt, [pv], [type])",
    "example": "=FV(8%/12,60,-10000,0)",
    "result": "734,769",
    "version": "All versions",
    "note": "",
    "slug": "fv",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "ipmt",
      "irr",
      "nper"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "NPV",
    "description": "Returns net present value for regular-period cash flows.",
    "syntax": "NPV(rate, value1, [value2], …)",
    "example": "=NPV(10%,B2:B6)+B1",
    "result": "Project NPV",
    "version": "All versions",
    "note": "",
    "slug": "npv",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "XNPV",
    "description": "Returns net present value for cash flows on irregular dates.",
    "syntax": "XNPV(rate, values, dates)",
    "example": "=XNPV(10%,B2:B6,A2:A6)",
    "result": "Project NPV",
    "version": "All versions",
    "note": "",
    "slug": "xnpv",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "IRR",
    "description": "Returns the internal rate of return for regular-period cash flows.",
    "syntax": "IRR(values, [guess])",
    "example": "=IRR(B2:B6)",
    "result": "18.4%",
    "version": "All versions",
    "note": "",
    "slug": "irr",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "nper"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "XIRR",
    "description": "Returns the internal rate of return for cash flows on irregular dates.",
    "syntax": "XIRR(values, dates, [guess])",
    "example": "=XIRR(B2:B6,A2:A6)",
    "result": "19.1%",
    "version": "All versions",
    "note": "",
    "slug": "xirr",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "RATE",
    "description": "Returns the interest rate per period.",
    "syntax": "RATE(nper, pmt, pv, [fv], [type], [guess])",
    "example": "=RATE(60,-22244,1000000)*12",
    "result": "12%",
    "version": "All versions",
    "note": "",
    "slug": "rate",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "NPER",
    "description": "Returns the number of periods required for a loan or investment.",
    "syntax": "NPER(rate, pmt, pv, [fv], [type])",
    "example": "=NPER(12%/12,-22244,1000000)",
    "result": "60",
    "version": "All versions",
    "note": "",
    "slug": "nper",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "IPMT",
    "description": "Returns the interest portion of a payment for one period.",
    "syntax": "IPMT(rate, per, nper, pv, [fv], [type])",
    "example": "=IPMT(12%/12,1,60,1000000)",
    "result": "-10,000",
    "version": "All versions",
    "note": "",
    "slug": "ipmt",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "irr",
      "nper"
    ]
  },
  {
    "category": "financial",
    "usage": "common",
    "name": "PPMT",
    "description": "Returns the principal portion of a payment for one period.",
    "syntax": "PPMT(rate, per, nper, pv, [fv], [type])",
    "example": "=PPMT(12%/12,1,60,1000000)",
    "result": "-12,244",
    "version": "All versions",
    "note": "",
    "slug": "ppmt",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Common",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "CUMIPMT",
    "description": "Returns cumulative interest paid between selected periods.",
    "syntax": "CUMIPMT(rate, nper, pv, start_period, end_period, type)",
    "example": "=CUMIPMT(12%/12,60,1000000,1,12,0)",
    "result": "Year 1 interest",
    "version": "All versions",
    "note": "",
    "slug": "cumipmt",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "CUMPRINC",
    "description": "Returns cumulative principal paid between selected periods.",
    "syntax": "CUMPRINC(rate, nper, pv, start_period, end_period, type)",
    "example": "=CUMPRINC(12%/12,60,1000000,1,12,0)",
    "result": "Year 1 principal",
    "version": "All versions",
    "note": "",
    "slug": "cumprinc",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "SLN",
    "description": "Returns straight-line depreciation for one period.",
    "syntax": "SLN(cost, salvage, life)",
    "example": "=SLN(1000000,100000,5)",
    "result": "180,000",
    "version": "All versions",
    "note": "",
    "slug": "sln",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "DB",
    "description": "Returns fixed-declining-balance depreciation.",
    "syntax": "DB(cost, salvage, life, period, [month])",
    "example": "=DB(1000000,100000,5,1)",
    "result": "369,000",
    "version": "All versions",
    "note": "",
    "slug": "db",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "DDB",
    "description": "Returns double-declining-balance or custom declining depreciation.",
    "syntax": "DDB(cost, salvage, life, period, [factor])",
    "example": "=DDB(1000000,100000,5,1)",
    "result": "400,000",
    "version": "All versions",
    "note": "",
    "slug": "ddb",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "SYD",
    "description": "Returns sum-of-years’ digits depreciation.",
    "syntax": "SYD(cost, salvage, life, per)",
    "example": "=SYD(1000000,100000,5,1)",
    "result": "300,000",
    "version": "All versions",
    "note": "",
    "slug": "syd",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "EFFECT",
    "description": "Returns the effective annual interest rate.",
    "syntax": "EFFECT(nominal_rate, npery)",
    "example": "=EFFECT(12%,12)",
    "result": "12.68%",
    "version": "All versions",
    "note": "",
    "slug": "effect",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "NOMINAL",
    "description": "Returns the nominal annual interest rate.",
    "syntax": "NOMINAL(effect_rate, npery)",
    "example": "=NOMINAL(12.68%,12)",
    "result": "12.00%",
    "version": "All versions",
    "note": "",
    "slug": "nominal",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "financial",
    "usage": "specialized",
    "name": "RRI",
    "description": "Returns an equivalent interest rate for investment growth.",
    "syntax": "RRI(nper, pv, fv)",
    "example": "=RRI(5,100000,150000)",
    "result": "8.45%",
    "version": "Excel 2013+",
    "note": "",
    "slug": "rri",
    "categoryLabel": "Loans, investments & finance",
    "categoryDescription": "Model payments, cash flows, returns and depreciation.",
    "usageLabel": "Specialized",
    "related": [
      "pmt",
      "fv",
      "ipmt",
      "irr"
    ]
  },
  {
    "category": "information",
    "usage": "most-common",
    "name": "ISBLANK",
    "description": "Returns TRUE when a cell is empty.",
    "syntax": "ISBLANK(value)",
    "example": "=ISBLANK(A2)",
    "result": "TRUE or FALSE",
    "version": "All versions",
    "note": "",
    "slug": "isblank",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Most used",
    "related": [
      "iserror",
      "isnumber",
      "iserr",
      "isformula"
    ]
  },
  {
    "category": "information",
    "usage": "most-common",
    "name": "ISNUMBER",
    "description": "Returns TRUE when a value is numeric.",
    "syntax": "ISNUMBER(value)",
    "example": "=ISNUMBER(125)",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "isnumber",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Most used",
    "related": [
      "isblank",
      "iserror",
      "iserr",
      "isformula"
    ]
  },
  {
    "category": "information",
    "usage": "common",
    "name": "ISTEXT",
    "description": "Returns TRUE when a value is text.",
    "syntax": "ISTEXT(value)",
    "example": "=ISTEXT(\"Excel\")",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "istext",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Common",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "common",
    "name": "ISLOGICAL",
    "description": "Returns TRUE when a value is TRUE or FALSE.",
    "syntax": "ISLOGICAL(value)",
    "example": "=ISLOGICAL(TRUE)",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "islogical",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Common",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "common",
    "name": "ISFORMULA",
    "description": "Returns TRUE when a cell contains a formula.",
    "syntax": "ISFORMULA(reference)",
    "example": "=ISFORMULA(F2)",
    "result": "TRUE",
    "version": "Excel 2013+",
    "note": "",
    "slug": "isformula",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Common",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "common",
    "name": "ISREF",
    "description": "Returns TRUE when a value is a valid reference.",
    "syntax": "ISREF(value)",
    "example": "=ISREF(A1)",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "isref",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Common",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "most-common",
    "name": "ISERROR",
    "description": "Returns TRUE for any Excel error value.",
    "syntax": "ISERROR(value)",
    "example": "=ISERROR(1/0)",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "iserror",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Most used",
    "related": [
      "isblank",
      "isnumber",
      "iserr",
      "isformula"
    ]
  },
  {
    "category": "information",
    "usage": "common",
    "name": "ISERR",
    "description": "Returns TRUE for any error except #N/A.",
    "syntax": "ISERR(value)",
    "example": "=ISERR(1/0)",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "iserr",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Common",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "isformula"
    ]
  },
  {
    "category": "information",
    "usage": "common",
    "name": "ISNA",
    "description": "Returns TRUE only for #N/A.",
    "syntax": "ISNA(value)",
    "example": "=ISNA(NA())",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "isna",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Common",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "specialized",
    "name": "ISEVEN",
    "description": "Returns TRUE when a number is even.",
    "syntax": "ISEVEN(number)",
    "example": "=ISEVEN(12)",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "iseven",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Specialized",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "specialized",
    "name": "ISODD",
    "description": "Returns TRUE when a number is odd.",
    "syntax": "ISODD(number)",
    "example": "=ISODD(13)",
    "result": "TRUE",
    "version": "All versions",
    "note": "",
    "slug": "isodd",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Specialized",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "common",
    "name": "TYPE",
    "description": "Returns a code describing the type of a value.",
    "syntax": "TYPE(value)",
    "example": "=TYPE(\"Excel\")",
    "result": "2",
    "version": "All versions",
    "note": "",
    "slug": "type",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Common",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "specialized",
    "name": "CELL",
    "description": "Returns information about a cell’s formatting, location or contents.",
    "syntax": "CELL(info_type, [reference])",
    "example": "=CELL(\"address\",C2)",
    "result": "$C$2",
    "version": "All versions",
    "note": "",
    "slug": "cell",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Specialized",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "information",
    "usage": "specialized",
    "name": "INFO",
    "description": "Returns information about the current operating environment.",
    "syntax": "INFO(type_text)",
    "example": "=INFO(\"osversion\")",
    "result": "Operating system information",
    "version": "All versions",
    "note": "",
    "slug": "info",
    "categoryLabel": "Validate & inspect values",
    "categoryDescription": "Check data types, errors, blanks and workbook information.",
    "usageLabel": "Specialized",
    "related": [
      "isblank",
      "iserror",
      "isnumber",
      "iserr"
    ]
  },
  {
    "category": "reference",
    "usage": "common",
    "name": "ROW",
    "description": "Returns the row number of a reference.",
    "syntax": "ROW([reference])",
    "example": "=ROW(C8)",
    "result": "8",
    "version": "All versions",
    "note": "",
    "slug": "row",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Common",
    "related": [
      "column",
      "columns",
      "rows",
      "sheet"
    ]
  },
  {
    "category": "reference",
    "usage": "common",
    "name": "ROWS",
    "description": "Returns the number of rows in a range or array.",
    "syntax": "ROWS(array)",
    "example": "=ROWS(A2:E6)",
    "result": "5",
    "version": "All versions",
    "note": "",
    "slug": "rows",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Common",
    "related": [
      "column",
      "columns",
      "row",
      "sheet"
    ]
  },
  {
    "category": "reference",
    "usage": "common",
    "name": "COLUMN",
    "description": "Returns the column number of a reference.",
    "syntax": "COLUMN([reference])",
    "example": "=COLUMN(C8)",
    "result": "3",
    "version": "All versions",
    "note": "",
    "slug": "column",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Common",
    "related": [
      "columns",
      "row",
      "rows",
      "sheet"
    ]
  },
  {
    "category": "reference",
    "usage": "common",
    "name": "COLUMNS",
    "description": "Returns the number of columns in a range or array.",
    "syntax": "COLUMNS(array)",
    "example": "=COLUMNS(A2:E6)",
    "result": "5",
    "version": "All versions",
    "note": "",
    "slug": "columns",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Common",
    "related": [
      "column",
      "row",
      "rows",
      "sheet"
    ]
  },
  {
    "category": "reference",
    "usage": "specialized",
    "name": "ADDRESS",
    "description": "Creates a cell address as text from row and column numbers.",
    "syntax": "ADDRESS(row_num, column_num, [abs_num], [a1], [sheet_text])",
    "example": "=ADDRESS(8,3)",
    "result": "$C$8",
    "version": "All versions",
    "note": "",
    "slug": "address",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Specialized",
    "related": [
      "column",
      "columns",
      "row",
      "rows"
    ]
  },
  {
    "category": "reference",
    "usage": "specialized",
    "name": "AREAS",
    "description": "Returns the number of separate areas in a reference.",
    "syntax": "AREAS(reference)",
    "example": "=AREAS((A1:B2,D1:E2))",
    "result": "2",
    "version": "All versions",
    "note": "",
    "slug": "areas",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Specialized",
    "related": [
      "column",
      "columns",
      "row",
      "rows"
    ]
  },
  {
    "category": "reference",
    "usage": "common",
    "name": "SHEET",
    "description": "Returns the sheet number of a reference.",
    "syntax": "SHEET([value])",
    "example": "=SHEET()",
    "result": "Current sheet number",
    "version": "Excel 2013+",
    "note": "",
    "slug": "sheet",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Common",
    "related": [
      "column",
      "columns",
      "row",
      "rows"
    ]
  },
  {
    "category": "reference",
    "usage": "common",
    "name": "SHEETS",
    "description": "Returns the number of sheets in a reference or workbook.",
    "syntax": "SHEETS([reference])",
    "example": "=SHEETS()",
    "result": "Workbook sheet count",
    "version": "Excel 2013+",
    "note": "",
    "slug": "sheets",
    "categoryLabel": "Build references & navigation",
    "categoryDescription": "Create flexible references and identify rows or columns.",
    "usageLabel": "Common",
    "related": [
      "column",
      "columns",
      "row",
      "rows"
    ]
  },
  {
    "category": "engineering",
    "usage": "common",
    "name": "CONVERT",
    "description": "Converts a number from one measurement unit to another.",
    "syntax": "CONVERT(number, from_unit, to_unit)",
    "example": "=CONVERT(10,\"km\",\"mi\")",
    "result": "6.2137",
    "version": "All versions",
    "note": "",
    "slug": "convert",
    "categoryLabel": "Convert & engineer values",
    "categoryDescription": "Convert units and work with technical number systems.",
    "usageLabel": "Common",
    "related": [
      "bin2dec",
      "dec2bin",
      "gestep"
    ]
  },
  {
    "category": "engineering",
    "usage": "specialized",
    "name": "DEC2BIN",
    "description": "Converts a decimal number to binary.",
    "syntax": "DEC2BIN(number, [places])",
    "example": "=DEC2BIN(10)",
    "result": "1010",
    "version": "All versions",
    "note": "",
    "slug": "dec2bin",
    "categoryLabel": "Convert & engineer values",
    "categoryDescription": "Convert units and work with technical number systems.",
    "usageLabel": "Specialized",
    "related": [
      "convert",
      "bin2dec",
      "gestep"
    ]
  },
  {
    "category": "engineering",
    "usage": "specialized",
    "name": "BIN2DEC",
    "description": "Converts a binary number to decimal.",
    "syntax": "BIN2DEC(number)",
    "example": "=BIN2DEC(\"1010\")",
    "result": "10",
    "version": "All versions",
    "note": "",
    "slug": "bin2dec",
    "categoryLabel": "Convert & engineer values",
    "categoryDescription": "Convert units and work with technical number systems.",
    "usageLabel": "Specialized",
    "related": [
      "convert",
      "dec2bin",
      "gestep"
    ]
  },
  {
    "category": "engineering",
    "usage": "specialized",
    "name": "GESTEP",
    "description": "Returns 1 when a number is greater than or equal to a threshold.",
    "syntax": "GESTEP(number, [step])",
    "example": "=GESTEP(8,5)",
    "result": "1",
    "version": "All versions",
    "note": "",
    "slug": "gestep",
    "categoryLabel": "Convert & engineer values",
    "categoryDescription": "Convert units and work with technical number systems.",
    "usageLabel": "Specialized",
    "related": [
      "convert",
      "bin2dec",
      "dec2bin"
    ]
  },
  {
    "category": "database",
    "usage": "specialized",
    "name": "DSUM",
    "description": "Adds values in a database field that meet criteria.",
    "syntax": "DSUM(database, field, criteria)",
    "example": "=DSUM(A1:E6,\"Sales\",G1:H2)",
    "result": "167,000",
    "version": "All versions",
    "note": "",
    "slug": "dsum",
    "categoryLabel": "Calculate from databases",
    "categoryDescription": "Apply criteria-based calculations to structured lists.",
    "usageLabel": "Specialized",
    "related": [
      "daverage",
      "dcount",
      "dget"
    ]
  },
  {
    "category": "database",
    "usage": "specialized",
    "name": "DCOUNT",
    "description": "Counts numeric records in a database field that meet criteria.",
    "syntax": "DCOUNT(database, field, criteria)",
    "example": "=DCOUNT(A1:E6,\"Sales\",G1:H2)",
    "result": "2",
    "version": "All versions",
    "note": "",
    "slug": "dcount",
    "categoryLabel": "Calculate from databases",
    "categoryDescription": "Apply criteria-based calculations to structured lists.",
    "usageLabel": "Specialized",
    "related": [
      "daverage",
      "dget",
      "dsum"
    ]
  },
  {
    "category": "database",
    "usage": "specialized",
    "name": "DAVERAGE",
    "description": "Averages values in a database field that meet criteria.",
    "syntax": "DAVERAGE(database, field, criteria)",
    "example": "=DAVERAGE(A1:E6,\"Sales\",G1:H2)",
    "result": "83,500",
    "version": "All versions",
    "note": "",
    "slug": "daverage",
    "categoryLabel": "Calculate from databases",
    "categoryDescription": "Apply criteria-based calculations to structured lists.",
    "usageLabel": "Specialized",
    "related": [
      "dcount",
      "dget",
      "dsum"
    ]
  },
  {
    "category": "database",
    "usage": "specialized",
    "name": "DGET",
    "description": "Returns the single database value that meets criteria.",
    "syntax": "DGET(database, field, criteria)",
    "example": "=DGET(A1:E6,\"Sales\",G1:H2)",
    "result": "125,000",
    "version": "All versions",
    "note": "",
    "slug": "dget",
    "categoryLabel": "Calculate from databases",
    "categoryDescription": "Apply criteria-based calculations to structured lists.",
    "usageLabel": "Specialized",
    "related": [
      "daverage",
      "dcount",
      "dsum"
    ]
  }
];
